/**
 * 工具函数
 */

import JsEncrypt from "jsencrypt";

export function encrypt(data) {
  let ert = JSON.stringify(data);
  let key = `-----BEGIN PUBLIC KEY-----
MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDGdXOsJ5wGbFpUGt2eKwsU3u3M
PJ9F39e0BozRVoTkp6KVE0Sk6/iaVlUYDmauN/VgJfOc1KTo+8km26OxskbFN3vU
yvHG3xxnXIkGduEe6c/kDFti2LYGChmXruNaTPa72JiSXYUZ3ZYvdHjn7oGIKM2j
cd1pWJkdYHSrKn+uSwIDAQAB
-----END PUBLIC KEY-----`;
  let encryption = new JSEncrypt();
  encryption.setPublicKey(key);
  let result = encryption.encrypt(ert);
  return result;
}

export function randomString(len) {
  var len = len || 32;
  /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
  var $chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
  var maxPos = $chars.length;
  var pwd = "";
  for (var i = 0; i < len; i++) {
    pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return pwd;
}

export function setCookie(name, value, day) {
  if (day !== 0) {
    //当设置的时间等于0时，不设置expires属性，cookie在浏览器关闭后删除
    var curDate = new Date();
    var curTamp = curDate.getTime();
    //返回距 1970 年 1 月 1 日之间的毫秒数
    var curWeeHours = new Date(curDate.toLocaleDateString()).getTime() - 1;
    var passedTamp = curTamp - curWeeHours;
    var leftTamp = 24 * 60 * 60 * 1000 - passedTamp;
    var leftTime = new Date();
    leftTime.setTime(leftTamp + curTamp);
    document.cookie =
      name + "=" + escape(value) + ";expires=" + leftTime.toGMTString();
  } else {
    document.cookie = name + "=" + escape(value);
  }
}

export function getCookie(name) {
  var arr;
  var reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if ((arr = document.cookie.match(reg))) {
    return unescape(arr[2]);
    //arr[2]对应的是变量name的值
  } else {
    return null;
  }
  document.cookie = name + "=" + escape(value);
  //value表示的是application中cookie的一列value值
}

export function removeCookie() {
  localStorage.clear();
  var date = new Date();
  date.setTime(date.getTime() - 10000);
  var cookies = document.cookie.match(/[^ =;]+(?=\=)/g);
  if (cookies) {
    for (var i = cookies.length; i--; )
      document.cookie =
        cookies[i] + "=; expire=" + date.toGMTString() + "; path=/";
  }
}



// WEBPACK FOOTER //
// ./src/util/index.js